import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getDoc,editDoc } from "../store/slices/mpd";
import { nameregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { GrUploadOption } from "react-icons/gr";

const EditMpd = () => {
  const { id } = useParams();
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [title, setTitle] = useState("");
  const [order, setOrder] = useState("");
const [fileUrl, setFileUrl] = useState("");
const [uploadError, setUploadError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDocumentDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getDoc(item)).unwrap();
        const gallery = data?.data;

        if (gallery) {
          setTitle(gallery.title || "");
      setFileUrl(gallery.file?.url || "");
         setOrder(gallery?.order?.toString() || "");
        }
      } catch (error) {
        console.error("Failed to fetch gallery details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDocumentDetails();
  }, [dispatch, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "title":
        setTitle(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid title"
            : "";
        break;

      default:
        break;
    }

    setErrors(validationErrors);
  };

const editDocument = async (e) => {

  e.preventDefault();

  setIsDisabled(true);

  setTimeout(() => {
    setIsDisabled(false);
  }, 3000);

  const validationErrors = {};

  if (!title.trim()) {
    validationErrors.title =
      "Please enter title";
  }

  if (!fileUrl) {
    validationErrors.file =
      "Please upload file";
  }
  if (!order) {
  validationErrors.order =
    "Please enter order";
}

  if (
    Object.keys(validationErrors).length > 0
  ) {
    setErrors(validationErrors);
    return;
  }

  const item = {
    id,

    title,
order,
    file: {
      url: fileUrl,
    },
  };

  try {

    await dispatch(
      editDoc(item)
    ).unwrap();

    alert(
      "Document updated successfully!"
    );

    navigate("/admin/mpd");

  } catch (error) {

    alert(
      error?.message ||
      "Something went wrong"
    );
  }
};

  function cancel(e) {
    navigate(-1);
  }

async function uploadFile(e) {

  setUploadError("");

  const selectedFile = e.target.files[0];

  if (!selectedFile) {
    setUploadError(
      "Please select a file"
    );
    return;
  }

  const allowedTypes = [
    "application/pdf",
  ];

  if (
    !allowedTypes.includes(
      selectedFile.type
    )
  ) {
    setUploadError(
      "Only PDF files allowed"
    );
    return;
  }

  if (
    selectedFile.size >
    10 * 1024 * 1024
  ) {
    setUploadError(
      "File size must be less than 10 MB"
    );
    return;
  }

  try {

    const formData = new FormData();

    formData.append(
      "file",
      selectedFile
    );

    const response = await fetch(
      `${API_BASE_URL}${API_PATHS.upload}`,
      {
        method: "POST",

        headers: {
          "x-access-token": token,
        },

        body: formData,
      }
    );

    const data =
      await response.json();

    if (
      data?.status === 1 &&
      data?.data?.location
    ) {

      setFileUrl(
        data.data.location
      );

      setErrors((prev) => ({
        ...prev,
        file: "",
      }));

    } else {

      setUploadError(
        "Upload failed"
      );
    }

  } catch (error) {

    console.log(error);

    setUploadError(
      "Something went wrong"
    );
  }
}

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit MPD</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/mpd"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              MPD
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit MPD</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={editDocument}>
            <div className="row mb-40">
              <div className="col-md-4">
                <label className="form-label">
                  Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="title"
                  value={title}
                  onChange={handleChange}
                  className={`form-control ${errors.title ? "is-invalid" : ""}`}
                  placeholder="Enter Tiitle"
                />
                {errors.title && (
                  <div className="text-danger mt-2">{errors.title}</div>
                )}
              </div>
<div className="col-md-4">
  <label className="form-label">
    Order
    <span className="text-danger">*</span>
  </label>

  <input
    type="text"
    inputMode="numeric"
    className={`form-control ${
      errors.order ? "is-invalid" : ""
    }`}
    placeholder="Enter Order"
    value={order}
    onChange={(e) => {

      const value =
        e.target.value.replace(/\D/g, "");

      setOrder(value);
    }}
  />

  {errors.order && (
    <div className="text-danger mt-2">
      {errors.order}
    </div>
  )}
</div>
              <div className="col-md-4">
                <label className="form-label">
                  Image<span className="text-danger">*</span>
                </label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload File
                </label>
                <input
                  type="file"
                  name="iconUrl"
                  id="fileInput"
                  accept="application/pdf"
                  onChange={uploadFile}
                  className={`form-control ${uploadError ? "is-invalid" : ""}`}
                />
                {errors.file && (
                  <div className="text-danger mt-2">{errors.file}</div>
                )}
                <br />
                {fileUrl && (
  <a
    href={fileUrl}
    target="_blank"
    rel="noreferrer"
    className="btn btn-outline-primary mt-3"
  >
    View Uploaded File
  </a>
)}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditMpd;
